import { connect } from 'react-redux';

import { setJobPriority } from '../../../ducks/jobs/thunks';

const connector = connect(null, {
  setJobPriority,
});

export default connector;
